import styled from 'styled-components';
import { Menu } from '../Menu/Menu';
import { themeColor } from '../theme/colors';

export const IDESelectorTargetContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-shrink: 0;

  .latestSelectedIdeButton, .dropdownButton {
    display: flex;
    align-items: center;

    border-radius: 8px;
    border: 1px solid ${themeColor('strokeLight')};
    cursor: pointer;
    height: 36px;
    box-sizing: border-box;
    background: ${themeColor('buttonBackground')};

    &:hover {
      background: ${themeColor('buttonBackgroundHover')};
    }
  }

  .latestSelectedIdeButton {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 0 11px;
  }

  .dropdownButton {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0 8px;
    svg {
      color: ${themeColor('gray')};
    }
  }
`

export const IDESelectorDropdown = styled(Menu.Dropdown)`
  padding: 8px;
  border-radius: 8px;

  .mantine-Menu-itemLabel {
    display: flex;
    align-items: center;
    gap: 11px;

    & > svg {
      width: 14px;
      height: 14px;
    }
  }

  .ideNotInstalled {
    font-size: 12px;
    p {
      margin: 0 8px;

      &:first-child {
        margin-top: 8px;
        margin-bottom: 4px;
      }
      &:last-child {
        margin-bottom: 8px;
      }
    }

    a {
      color: ${themeColor('linkColor')};
    }
  }

`
